module.exports = __webpack_public_path__ + "static/img/video_6.542af48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_6.jpg
// module id = HIlK
// module chunks = 1